import * as angular from 'angular';

import { ComponentDefinition, IDateRangePickerOptions } from '../../models';
import { ISpotValueHelperService } from '../../services';
import { ILogbookSeriesTableValue } from './logbookSeriesTableValue';

class LogbookSeriesTableEditor implements angular.IComponentController {
    dateOptions: IDateRangePickerOptions;

    readonly formController: angular.IFormController;
    readonly isEditMode : boolean;
    readonly onChange: () => void;
    readonly onLoadHistory: () => void;
    readonly values: ILogbookSeriesTableValue[];

    static $inject = ['spotValueHelperService'];

    constructor(
        private _spotValueHelperService: ISpotValueHelperService
    ) {
    }

    $onInit() {
        const options = this._spotValueHelperService.getDateOptions();
        options.drops = 'up';
        options.eventHandlers = { 'apply.daterangepicker': (_event, _data) => this.change() };
        this.dateOptions = options;
    }

    change() {
        if (this.onChange) {
            this.onChange();
        }
    }
}

export const wtLogbookSeriesTableEditor: ComponentDefinition = {
    componentId: 'wtLogbookSeriesTableEditor',
    controller: LogbookSeriesTableEditor,
    template: require('./logbookSeriesTableEditor.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '<?',
        isEditMode: '<',
        onChange: '&?',
        onLoadHistory: '&?',
        values: '<',
    }
};